/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsRefundsCtrl
 * @description
 */
angular.module('mercury.modules.reports.refunds')
.controller('ReportsRefundsCtrl', ["$filter", "ReportRefunds", "reporttime", "$scope", "title", function($filter, ReportRefunds, reporttime, $scope, title) {
  title.set('Refunds Report');

  $scope.loading = ReportRefunds.getByInterval(reporttime.start(), reporttime.end(), reporttime.interval());
  $scope.loading.then(function(results) {
    $scope.refunds = results;

    $scope.totalRefunds = $filter('sumof')($scope.refunds, 'refunds');
  });

  // Column definition for the main column graph
  $scope.refundsGraphColums = [
    {label: 'Period', type: 'string', key: 'startTime', filter: 'reporttimeformat'},
    {label: 'Amount', type: 'number', key: 'refunds', filter: 'currency'}
  ];
}]);
